import React, { memo } from 'react';

import { useSelector } from 'react-redux';
import { string } from 'prop-types';
import cn from 'classnames';
import { Spinner } from '@picsio/ui';

import {
  selectEffectiveChannelState,
  selectIsVariantChannelPanelHydrating,
  selectMasterProduct,
} from '../../store/selectors/productSelectors';
import ProductStateTabs from './ProductStateTabs';
import ConnectChannelSection from './ConnectChannelSection';
import styles from './styles.module.scss';

const ProductInfo = ({ productId, variantId }) => {
  const product = useSelector((state) => selectMasterProduct(state, productId));
  const { isMasterView } = useSelector((state) => selectEffectiveChannelState(state, productId, variantId));
  const isVariantChannelPanelHydrating = useSelector(
    (state) => selectIsVariantChannelPanelHydrating(state, productId, variantId),
  );

  if (!product._id || product.isLoading || isVariantChannelPanelHydrating) {
    return (
      <div className="InfoPanel">
        <Spinner text="Loading data..." />
      </div>
    );
  }

  return (
    <div className={`InfoPanel${product.isBusy ? ` ${styles.disabled}` : ' '} `}>
      <If condition={isMasterView}>
        <div data-qa="details-header" className={cn('detailsPanel__header  detailsPanel__btns', styles.header)}>
          <ConnectChannelSection productId={productId} variantId={variantId} />
        </div>
      </If>
      <ProductStateTabs productId={productId} variantId={variantId} />
    </div>
  );
};

ProductInfo.propTypes = {
  productId: string.isRequired,
  variantId: string,
};

ProductInfo.defaultProps = {
  variantId: null,
};

export default memo(ProductInfo);
